import React, { Component } from 'react';
import intl from 'react-intl-universal';

class Quantity extends Component{
    constructor(props){
        super(props)
        this.state={
            value: '',
            errorTip: false,
            lastTimeStamp: 0
        }

        this.updateQuantity = this.updateQuantity.bind(this);
    }
    componentDidMount(){
        this.setState({
            value: this.props.itemData.product.productInventory.quantity
        })
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return
        }
    }
    handlerChange(isChecked, initQuantity, minNum, maxNum, supplierId, cartId, itemcode, e){
        let _val = e.target.value;

        //开头不能为0，且不能输入小数, 只能输入整数
        _val = _val.replace(/[^\d]/g,'').replace(/^0{1,}/g,'');

        //设置事件发生时的时间戳
        this.setState({
            lastTimeStamp: e.timeStamp
        })

        if(_val === '' || _val < minNum || _val > maxNum){
            this.setState({
                value: _val,
                errorTip: true
            }, ()=>{
                let curTop = this.getTargetTop(e.target);
                this.creatLimitTip(minNum, maxNum, curTop);
            })
        }else{
            this.setState({
                value: _val,
                errorTip: false
            }, ()=>{
                this.removeLimitTip();
            })

            setTimeout(()=>{
                if(this.state.lastTimeStamp === e.timeStamp){
                     this.updateQuantity(isChecked, supplierId, cartId, itemcode, _val, initQuantity);
                }
            }, 400);
        }
    }
    handlerBlur(initQuantity, minNum, maxNum, cartId, e){
        let _val = e.target.value;

        if(_val === '' || _val < minNum || _val > maxNum){
            this.setState({
                value: initQuantity,
                errorTip: false
            })
        }else{
            this.setState({
                value: _val,
                errorTip: false
            })
        }

        this.removeLimitTip();
    }
    handleLessQuantity(isChecked, isDisabeld, initQuantity, minNum, maxNum, supplierId, cartId, itemcode){
        if(isDisabeld){
            return
        }

        let { value } = this.state;
        let countNum = parseInt(value)-1;

        if(countNum < minNum){
            return
        }

        this.setState({
            value: countNum
        })

        this.updateQuantity(isChecked, supplierId, cartId, itemcode, countNum, initQuantity);
    }
    handleMoreQuantity(isChecked, isDisabeld, initQuantity, minNum, maxNum, supplierId, cartId, itemcode){
        if(isDisabeld){
            return
        }

        let { value } = this.state;
        let countNum = parseInt(value)+1;

        if(countNum > maxNum){
            return
        }

        this.setState({
            value: countNum
        });

        this.updateQuantity(isChecked, supplierId, cartId, itemcode, countNum, initQuantity);
    }
    updateQuantity(isChecked, supplierId, cartId, itemcode, quantity, initQuantity){
        this.props.updateQuantity(isChecked, supplierId, cartId, itemcode, quantity, ()=>{
            //如果接口请求失败，输入框恢复为修改前的数值
            this.setState({
                value: initQuantity
            })
        })
    }
    onRemove(isChecked, supplierId, cartId, itemcode, isMix, GAname) {
        this.props.onRemove(isChecked, supplierId, cartId, itemcode, isMix)
    }
    getTargetTop(target){
        let listWrap = document.getElementsByClassName('express-cart-list');
        let curTop = target.offsetTop - listWrap[0].scrollTop - 8;
        return curTop;
    }
    creatLimitTip(minQuantity, maxQuantity, targetTop){
        let rightCartWrap = window.parent.document.getElementById('rightExpressCart');
        //先删除之前的
        let errToast = rightCartWrap.getElementsByClassName('quantity-err-toast');
        console.log(errToast.length );
        errToast.length > 0 && rightCartWrap.removeChild(errToast[0]);

        let tipDom = window.parent.document.createElement('div');
        tipDom.setAttribute('class', 'quantity-err-toast');
        tipDom.innerHTML = intl.get('cart_notice_only') + ' ' + minQuantity + ' ' + intl.get('cart_notice_to') + ' ' + maxQuantity + ' ' + intl.get('cart_notice_allowed');
        tipDom.style.position = 'absolute';
        tipDom.style.top = targetTop + 'px';
        tipDom.style.right = '138px';
        tipDom.style.padding = '10px';
        tipDom.style.minWidth = '200px';
        tipDom.style.color = '#fff';
        tipDom.style.textAlign = 'center';
        tipDom.style.fontSize = '14px';
        tipDom.style.borderRadius = '6px';
        tipDom.style.background = 'rgba(0, 0, 0, 0.8)';

        rightCartWrap.appendChild(tipDom);
    }
    removeLimitTip(){
        let rightCartWrap = window.parent.document.getElementById('rightExpressCart');
        let curErr = rightCartWrap.getElementsByClassName('quantity-err-toast');
        curErr.length > 0 && rightCartWrap.removeChild(curErr[0]);
    }

    render(){
        let { itemData, supplierId } = this.props;
        let { cartId, productInventory, productBase, productMark } = itemData.product;

        return(
            <div className='cart-quantity'>
                <span className={`less-quantity-btn ${
                    productInventory.quantity <= productInventory.minQuantity || (!!productMark.isSample && productMark.isSample === '1') || ((!!productInventory.maxQuantity && productInventory.maxQuantity === 0) || !!productInventory.noSale)
                    ?
                    'disabled'
                    :
                    ''
                }`}
                onClick={this.handleLessQuantity.bind(
                    this,
                    itemData.isChecked,
                    productInventory.quantity <= productInventory.minQuantity || (!!productMark.isSample && productMark.isSample === '1') || ((!!productInventory.maxQuantity && productInventory.maxQuantity === 0) || !!productInventory.noSale) ? true : false,
                    productInventory.quantity,
                    productInventory.minQuantity,
                    productInventory.maxQuantity,
                    supplierId,
                    cartId,
                    productBase.itemcode
                )}
                spm-index="reduce"
                event-type="click"
                event-code="VDLw9Ghh749L"
                ></span>
                <input
                    type="text"
                    maxLength="6"
                    autoComplete="off"
                    value={this.state.value}
                    className={(!!productMark.isSample && productMark.isSample === '1') || ((!!productInventory.maxQuantity && productInventory.maxQuantity === 0) || !!productInventory.noSale) ? 'disabled' : ''}
                    disabled={(!!productMark.isSample && productMark.isSample === '1') || ((!!productInventory.maxQuantity && productInventory.maxQuantity === 0) || !!productInventory.noSale) ? 'disabled' : ''}
                    onChange={this.handlerChange.bind(this, itemData.isChecked, productInventory.quantity, productInventory.minQuantity, productInventory.maxQuantity, supplierId, cartId, productBase.itemcode)}
                    onBlur={this.handlerBlur.bind(this, productInventory.quantity, productInventory.minQuantity, productInventory.maxQuantity, cartId )}
                    onPaste={(e) => e.preventDefault()} />
                <span className={`more-quantity-btn ${
                    productInventory.quantity >= productInventory.maxQuantity || (!!productMark.isSample && productMark.isSample === '1') || ((!!productInventory.maxQuantity && productInventory.maxQuantity === 0) || !!productInventory.noSale)
                    ?
                    'disabled'
                    :
                    ''
                }`}
                onClick={this.handleMoreQuantity.bind(
                    this,
                    itemData.isChecked,
                    productInventory.quantity >= productInventory.maxQuantity || (!!productMark.isSample && productMark.isSample === '1') || ((!!productInventory.maxQuantity && productInventory.maxQuantity === 0) || !!productInventory.noSale) ? true : false,
                    productInventory.quantity,
                    productInventory.minQuantity,
                    productInventory.maxQuantity,
                    supplierId,
                    cartId,
                    productBase.itemcode
                )}
                spm-index="add"
                event-type="click"
                event-code="ivjRTMmPMVXu"
                ></span>
            </div>
        )
    }
}

export default Quantity
